import axios from 'axios'
import { useEffect } from 'react'
import { useRouterHook } from '../hooks/useRouterHook'

const instance = axios.create()

const AxiosInterceptor = ({ children }) => {
  const { router } = useRouterHook()
  useEffect(() => {
    const resInterceptor = (response) => {
          // Extract cookies from the response headers
          const setCookieHeader = response.headers['set-cookie']
          if (setCookieHeader) {
            setCookieHeader.forEach((cookie) => {
              // Manually set the cookie in the browser
              document.cookie = cookie
            })
          }
      
      return response
    }

    const errInterceptor = async (error) => {
      const isHire = router?.asPath?.split('/')?.includes('hire')
      // if (error.response.status === 401 && process?.env?.NEXT_PUBLIC_APP_ENV != 'local') {
      //   await logOutHandler({ utmParams, window, loginDetails, location, cookie, setLoginDetails, setEnterpriseLoginDetails, setIsJobProfileCreated })
      //   if (isHire)
      //     replaceThePageInAdvertiser({
      //       pathName: 'advertiserHomePage',
      //       as: '',
      //       isHistoryPop: false,
      //       isHome: true
      //     })
      //   else setLogInOpen(true)
      // }

      return Promise.reject()
    }

    const interceptor = instance.interceptors.response.use(resInterceptor, errInterceptor)

    return () => instance.interceptors.response.eject(interceptor)
  }, [router])

  return children
}

export default instance
export { AxiosInterceptor }
